import { Box } from '@wix/design-system';
import React, { ComponentProps, forwardRef, PropsWithChildren, useEffect } from 'react';

import { useForwardedRef } from './useForwardedRef';

type ScrollBoxProps = ComponentProps<typeof Box> &
  PropsWithChildren<{
    onScroll?: (e: Event) => void;
  }>;

export const ScrollBox = forwardRef<HTMLDivElement, ScrollBoxProps>(
  ({ children, onScroll, ...props }, ref) => {
    const innerRef = useForwardedRef(ref);

    useEffect(() => {
      if (!onScroll) {
        return;
      }

      innerRef.current?.addEventListener('scroll', onScroll);

      return () => innerRef.current?.removeEventListener('scroll', onScroll);
    }, [onScroll]);

    return (
      <Box ref={innerRef} overflowY="auto" {...props}>
        {children}
      </Box>
    );
  },
);
